var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('hr'),_vm._v(" "),_c('span',[_vm._v("©2017 Rowan Winsemius & Vaibhavraj Roham")])])}]

export { render, staticRenderFns }